<div class="modal" [ngClass]="{'modal--with-box': withBox, 'modal--table': table}">
    <div class="modal__content">
        <div (click)="modalClose.emit()" class="circle-button circle-button--fixed modal__close-button" *ngIf="dismissable">
            <img src="assets/icons/icon-x.svg" alt="">
        </div>
        <ng-content></ng-content>
    </div>

    <div class="modal__backdrop" (click)="modalClose.emit()">

    </div>
</div>
